import type React from "react"

export const User: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>User</title>
    <path d="M8.5 9.5H5.5C2.4375 9.5 0 11.9688 0 15C0 15.5625 0.4375 16 1 16H13C13.5312 16 14 15.5625 14 15C14 11.9688 11.5312 9.5 8.5 9.5ZM1.5 14.5C1.75 12.5312 3.4375 11 5.5 11H8.5C10.5312 11 12.2188 12.5312 12.4688 14.5H1.5ZM7 8C9.1875 8 11 6.21875 11 4C11 1.8125 9.1875 0 7 0C4.78125 0 3 1.8125 3 4C3 6.21875 4.78125 8 7 8ZM7 1.5C8.375 1.5 9.5 2.625 9.5 4C9.5 5.40625 8.375 6.5 7 6.5C5.59375 6.5 4.5 5.40625 4.5 4C4.5 2.625 5.59375 1.5 7 1.5Z" />
  </svg>
)
